import Keycloak, { KeycloakInstance } from 'keycloak-js';

const { hostname, protocol } = window.location;

let treatedHost = hostname;
let treatedProtocol = protocol;

if (hostname === 'localhost' && process.env.REACT_APP_HML_HOSTNAME) {
  treatedHost = process.env.REACT_APP_HML_HOSTNAME;
  treatedProtocol = 'https:';
} else if (hostname === 'iot.algar.com.br') {
  treatedHost = 'sso.iot.algar.com.br';
}

const keycloak = new Keycloak({
  url: `${treatedProtocol}//${treatedHost}/auth`,
  realm: '1e6b4065',
  clientId: 'portal',
});

/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-var */
declare global {
  // eslint-disable-next-line vars-on-top
  var KEYCLOAK: KeycloakInstance;
}
window.KEYCLOAK = keycloak;

export default keycloak;
